import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { DsAbstractLoadingComponent } from '@abstract/components/ds-abstract-loading.component';
import { DsLoadingSize } from '@type/ds-loading-size.type';
import { DsLoadingBarMode } from '@design-system/ds-loading-bar/types/ds-loading-bar-mode.type';

@Component({
  selector: 'ds-loading-bar',
  standalone: true,
  imports: [NgClass, MatProgressBarModule],
  templateUrl: './ds-loading-bar.component.html',
  styleUrls: ['./ds-loading-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsLoadingBarComponent extends DsAbstractLoadingComponent {
  /**
   * Controls bar thickness. Maps to height tokens unless the host overrides height.
   *
   * @default 'sm'
   */
  @Input() override size: DsLoadingSize = 'sm';

  /**
   * Animation mode. Use `determinate` with `value` for known progress.
   *
   * @default 'indeterminate'
   */
  @Input() mode: DsLoadingBarMode = 'indeterminate';

  /**
   * Progress percentage from 0 to 100. Used when `mode` is `determinate`.
   *
   * @default 0
   */
  @Input() value = 0;
}
